import { NoteAlertIcon } from './NoteAlertIcon';

/**
 * author: Colton Wiscombe
 * id 1673B5E0-CB7A-4430-9D36-9B42F1189D4F
 * name note-alert
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/note-alert.svg
 * tags
 * - Alert / Error 
 */
export const StickyNoteAlertIcon = NoteAlertIcon;
export default StickyNoteAlertIcon